var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgPinned = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#717179",
  d: "m14.829 14.828 5.656-5.657.707.707 1.415-1.414-7.071-7.071-1.415 1.414.707.707L9.172 9.17H6.343L4.93 10.585l3.677 3.677-4.243 4.243 1.132 1.13 4.242-4.242 3.677 3.677 1.415-1.414z"
})));
export default SvgPinned;